import { jsx as _jsx } from "react/jsx-runtime";
var SocialLink = function SocialLink(_ref) {
  var link = _ref.link,
    Icon = _ref.icon,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 18 : _ref$size;
  return /*#__PURE__*/_jsx("a", {
    href: link,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "px-12 text-inherit",
    children: /*#__PURE__*/_jsx(Icon, {
      size: size,
      ignoreColor: true,
      className: "fill-current "
    })
  });
};
export default SocialLink;